import React, { useState } from "react";
import Drawer from "@material-ui/core/Drawer";
import Icon from "Icons/SvgIcons";
import Nav from "components/HOCs/MenuNav/Nav/Nav";
import './DrawerComponent.scss';
import { Route, Switch } from "react-router-dom";

const DrawerComponent = ({onAuth, setAuth, routes}) => {
	const [menuStatus, setMenuStatus] = useState({ left: false });

	return (
		<div className="header__sidebarMenu">
			<div className="sidebarMenu__containerButton">
				<Icon
					svg="menu"
					classes="containerButton__svgIcon--openMenu"
					title="menu"
					click={() => setMenuStatus({left: true})}
				></Icon>
			</div>
			<h1 className="sidebarMenu__title">
				<Switch>
					{routes.map((route, index) => (
						<Route
							key={index}
							path={route.path}
							exact={route.exact}
							children={<route.sidebar />}
						/>
					))}
				</Switch>
			</h1>
			<Drawer
				anchor={"left"}
				open={menuStatus["left"]}
				onClose={() => setMenuStatus({left: false})}
			>
				<div className="sidebarMenu__containerButton">
					<Icon
						svg="close"
						classes="containerButton__svgIcon--close"
						title="close"
						click={() => setMenuStatus(false)}
					></Icon>
				</div>
				<Nav
					setMenuStatus={setMenuStatus}
					menuMobile={true}
					onAuth={onAuth}
					setAuth={setAuth}
				/>
			</Drawer>
		</div>
	);
};

export default DrawerComponent;
